import './style.css'

const Card = ({ children, boxShadow = false }) => {
    return (
        <div className={`card ${boxShadow && 'card-shadow'}`}>
            {children}
        </div>
    )
}

export default Card